<template>
  <div class="empty-chart">
    <slot></slot>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
.empty-chart {
  position: absolute;
  top: 15px;
  bottom: 15px;
  left: 15px;
  right: 15px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
}
</style>
